import { ISnotrRoute } from '..';

export default [
  {
    path: '/work-relation/:id/paycheck-template',
    name: 'PaycheckLineTemplate',
    meta: {
      title: 'TabTitle.paycheckLineTemplate',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/paycheck-line-template.vue'),
  },
  {
    path: '/work-relation/:id/simplified-paycheck-template',
    name: 'SimplifiedPaycheckTemplate',
    meta: {
      title: 'TabTitle.paycheckLineTemplate',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/simplified-paycheck-template.vue'),
  },
] as ISnotrRoute[];
